
// src/web/components/group-settings-page.jsx

import React from 'react'
import connect from '../../connects/group-settings-page.js'
import {
  SettingsPage,
  SettingsPanel,
} from './settings-page'
import GroupFormPanel from './group-form-panel.jsx'
import GroupMembersPanel from './group-members-panel.jsx'
import GroupTemplatesPanel from './group-templates-panel.jsx'
import TemplateFormPanel from './template-form-panel.jsx'
import GroupKPIPanel from './group-kpi-panel.jsx'
import KPIFormPanel from './kpi-form-panel.jsx'
import GroupExportPanel from './group-export-panel.jsx'
import GroupRemindPanel from './group-remind-panel.jsx'
import GroupReportPanel from './group-report-panel.jsx'
import GroupDeletePage from './group-delete-page.jsx'

class GroupSettingsPage extends React.Component {
  render() {
    const {
      t,
      user,
      group,
      active,
      onClose,
      name,
    } = this.props

    return (
      <SettingsPage title={t('label:グループ設定')}
          active={active}
          onCloseDialog={onClose}
          name={name}
          initialName="members" >
        <SettingsPanel name="profile"
            params={{ group: group }}
            label={t('label:基本設定')}
            icon="group_work"
            component={GroupFormPanel} />
        <SettingsPanel name="members"
            params={{ group: group }}
            label={t('label:メンバー管理')}
            icon="people"
            component={GroupMembersPanel} />
        <SettingsPanel name="remind"
            params={{ group: group }}
            label={t('label:リマインド通知')}
            icon="alarm"
            component={GroupRemindPanel} />
        <SettingsPanel name="report"
            params={{ group: group }}
            label={t('label:レポート')}
            icon="event_note"
            component={GroupReportPanel} />
        <SettingsPanel name="templates"
            params={{ group: group }}
            label={t('label:共通テンプレート')}
            icon="edit"
            component={GroupTemplatesPanel}
            subPanel={{
              new: { component: TemplateFormPanel, label: t('label:新規作成')},
              edit: { component: TemplateFormPanel, label: t('label:編集')},
            }} />
        <SettingsPanel name="kpi"
            params={{ group: group }}
            label={t('label:KPI設定')}
            icon="insert_chart"
            component={GroupKPIPanel}
            subPanel={{
              new: { component: KPIFormPanel, label: t('label:新規作成')},
              edit: { component: KPIFormPanel, label: t('label:編集')},
            }} />
        <SettingsPanel name="export"
            params={{ group, user }}
            label={t('label:エクスポート')}
            icon="cloud_download"
            component={GroupExportPanel} />
        <SettingsPanel name="delete"
            params={{ group, user }}
            label={t('label:ごみ箱に移動')}
            icon="delete"
            component={GroupDeletePage} />
        </SettingsPage>
    )
  }
}

export const RawGroupSettingsPage = GroupSettingsPage
export default connect(GroupSettingsPage)



// WEBPACK FOOTER //
// ./src/web/components/group-settings-page.jsx